var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-content-center pt_10 pb_10"},[_c('a',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":require("../assets/images/login-logo.png"),"alt":"PBE Login"}})])])
}]

export { render, staticRenderFns }